const keyFor = (userId, gameId) => `golf-last-visit:${userId}:${gameId}`;

export function readGameVisit(userId, gameId) {
  try {
    const visit = JSON.parse(localStorage.getItem(keyFor(userId, gameId)));
    if (!userId || !Number.isInteger(visit?.hole) || visit.hole < 1 || !Number.isFinite(visit.visitedAt)) return null;
    return visit;
  } catch { return null; }
}

export function rememberGameVisit(userId, gameId, hole) {
  if (!userId || !gameId || !Number.isInteger(hole)) return;
  try {
    localStorage.setItem(keyFor(userId, gameId), JSON.stringify({ hole, visitedAt: Date.now() }));
  } catch { /* Resuming remains optional if browser storage is unavailable. */ }
}

export function getResumePath(game, userId) {
  const visit = readGameVisit(userId, game.gameId);
  return `/games/${game.gameId}${game.status === 'inProgress' && visit ? `?hole=${visit.hole}` : ''}`;
}

export function mostRecentPlayableGame(games, userId) {
  return games.filter(game => game.status === 'inProgress' &&
    (game.admin === userId || game.scoringType === 'individual'))
    .sort((a, b) => (readGameVisit(userId, b.gameId)?.visitedAt || Date.parse(b.createdAt) || 0) -
      (readGameVisit(userId, a.gameId)?.visitedAt || Date.parse(a.createdAt) || 0))[0];
}
